export type ObservabilityHttpSpan = {
  updateName: (name: string) => unknown;
  setAttributes: (attributes: Record<string, string>) => unknown;
};

export type ObservabilityHttpRequest = { type: 'fetch' | 'xhr'; method: string; url: string };

type HttpSpanHook = (span: ObservabilityHttpSpan, request: ObservabilityHttpRequest) => void;

let hook: HttpSpanHook | undefined;

export function setObservabilityHttpSpanHook(next: HttpSpanHook | undefined) {
  hook = next;
}

export function dispatchHttpRequestSpan(span: ObservabilityHttpSpan, request: ObservabilityHttpRequest) {
  hook?.(span, request);
}
